import InputLabel from "../common/InputLabel";
import ToggleChip from "../common/ActionChip/ToggleChip";
import './index.css'
import { PersonFormModel, PersonProjects } from "../../models/user.model";


interface PersonFormProps {
  personForm: PersonFormModel,
  action?: string,
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  errors?: string[]
  projectsList: PersonProjects[]
}

export default function PersonForm({ personForm, action = 'view', handleChange, projectsList, errors = [] }: PersonFormProps) {

  const onClickProject = (event: React.ChangeEvent<any>) => {
    let newProjectsList: string[] = personForm.projects
    if (event.target.value === 'true') {
      newProjectsList = newProjectsList.filter(elem => elem !== event.target.name)
    } else {
      newProjectsList.push(event.target.name)
    }
    const newEvent = {
      'target': {
        'name': 'projects',
        'value': newProjectsList
      }
    } as React.ChangeEvent<any>

    handleChange(newEvent)
  }

  return <>
    <div className="persons-action-form">
      <div className="persons-action-form-item">
        <InputLabel
          label='Nombre'
          name='name'
          value={personForm.name}
          disabled={action === 'view'}
          onChange={handleChange}
          required
          error={errors.includes('name') && personForm.name.length === 0}
        />
      </div>

      <div className="persons-action-form-item">
        <InputLabel
          label='Apellido'
          name='last_name'
          value={personForm.last_name}
          disabled={action === 'view'}
          onChange={handleChange}
          required
          error={errors.includes('last_name') && personForm.last_name.length === 0}
        />
      </div>

      <div className="persons-action-form-item">
        <InputLabel
          label='Email'
          name='email'
          value={personForm.email}
          disabled={action === 'view'}
          onChange={handleChange}
          required
          error={errors.includes('email') && personForm.email.length === 0}
        />
      </div>

      <div className="persons-action-form-item">
        <InputLabel
          label='Teléfono'
          name='cellphone'
          value={personForm.cellphone}
          disabled={action === 'view'}
          onChange={handleChange}
        />
      </div>

      {(action === 'view' || action === 'edit') && (<>

        <div className="persons-action-form-item">
          <InputLabel
            label='Fecha de Creación'
            name='created_date'
            value={personForm.created_date}
            disabled
            onChange={handleChange}
          />
        </div>
      </>)}

      <div className="persons-action-form-itemfull">

        <label>Proyectos *
          <span className="persons-action-form_projects__error-message">
            {(errors.includes('projects') && personForm.projects.length === 0) ? "selecciona al menos uno" : ''}
          </span>
        </label>
        <div className={`persons-action-form__projects ${action === 'view' ? 'disabled' : ''}`}>
          {projectsList.map((item, index) => (
            <ToggleChip
              key={item.id}
              label={item.label}
              name={item.id}
              value={personForm.projects.includes(item.id)}
              onClick={onClickProject}
              disabled={action === 'view'}
            />
          ))
          }

        </div>
      </div>
    </div>
  </>
}